<template>
  <div>
    <!-- Kopfzeile: Titel, Button, Suchfeld in einer Zeile -->
    <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">

     <h3 class="mb-0">
        {{ config.title }}
        <span v-if="!isLoading" class="badge bg-secondary ms-2">{{ data.length }} db</span>
      </h3>

      <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
        <button class="btn btn-sm btn-success me-2" @click="scrollToNewRow">
          <i class="fas fa-plus"></i> Új sorhoz ugrás
        </button>

        <input
          v-model="search"
          class="form-control form-control-sm"
          placeholder="Keresés..."
          @input="fetchData"
        />
      </div>
    </div>


    <div v-if="isLoading" class="text-center my-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Betöltés...</span>
      </div>
    </div>


    <div class="table-container">
      <table class="table table-bordered table-sm">
        <thead class="sticky-header">
          <tr>
            <th v-for="field in visibleFields" :key="field.key">{{ field.label }}</th>
            <th>Művelet</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in data" :key="row.az">
            <td v-for="field in visibleFields" :key="field.key">
              <template v-if="editRow === row.az && !field.readonly">
                <select v-if="field.options" v-model="row[field.key]" class="form-control form-control-sm">
                  <option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                </select>
                <input v-else v-model="row[field.key]" class="form-control form-control-sm" />
              </template>
              <span v-else>
                <span
                  v-if="field.key === 'gps'"
                  class="text-primary text-decoration-underline"
                  style="cursor: pointer"
                  @click="openMap(row[field.key])"
                >
                  {{ row[field.key] }}
                </span>
                <span v-else>
                  {{ row[field.key] }}
                </span>
              </span>
            </td>
            <td>
              <button 
                class="btn btn-sm me-1"
                :class="editRow === row.az ? 'btn-success' : 'btn-outline-secondary'"
                @click="editRow === row.az ? saveRow(row) : startEdit(row)"
              >
                <i v-if="editRow !== row.az" class="fas fa-edit text-muted"></i>
                <i v-else class="fas fa-check text-white"></i>
              </button>

              <button 
                v-if="editRow === row.az" 
                class="btn btn-sm btn-danger" 
                @click="editRow = null"
              >
                <i class="fas fa-times"></i>
              </button>

            <!-- 🔹 NEU: Karte öffnen, nur für utvonal -->
              <button
                v-if="configKey === 'utvonal'"
                class="btn btn-sm btn-primary"
                @click="openRouteMap(row)"
              >
                <i class="fas fa-map-marked-alt"></i>
              </button>

            </td>
          </tr>
          <tr ref="newRow">
           <td v-for="field in visibleFields" :key="field.key">
              <select v-if="field.options" v-model="newRow[field.key]" class="form-control form-control-sm">
                <option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
              </select>
              <input 
                v-else
                v-model="newRow[field.key]"
                class="form-control form-control-sm"
                :readonly="field.readonly"
              />
            </td>
            <td>
              <button class="btn btn-sm btn-success me-1" @click="addRow">
                <i class="fas fa-save text-white"></i>
              </button>
              <button class="btn btn-sm btn-danger" @click="resetNewRow">
                <i class="fas fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

<map-modal 
  v-show="showMap" 
  :gps="selectedGPS" 
  :visible="showMap"
  @close="showMap = false"
/>


    </div>

    <div v-if="isLoading" class="text-center my-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Betöltés...</span>
      </div>
    </div>



  </div>

 

</template>


<script>
import axiosInstance from '@/axiosInstance';
import { mapGetters } from 'vuex';
import MapModal from '@/components/MapModal.vue';



export default {
  name: 'StammdatenTable',
  props: ['config', 'configKey'],
  emits: ['edit-start'], // ⬅️ HINZUFÜGEN

  
components: {
    MapModal
  },

  data() {
    return {
      data: [],
      editRow: null,
      newRow: {},
      search: '',
      isLoading: false, // 👈 Neu
      showMap: false,
    selectedGPS: '',
    };
  },
  computed: {
    ...mapGetters(['getUserData']),
    ceg_az() {
      return this.getUserData?.ceg_az || '';
    },
    visibleFields() {
        return this.config.fields.filter(f => f.visible !== false);
      }
  },



  created() {
   // this.fetchData();
  },

watch: {
  configKey: {
    immediate: true,
    handler() {
      this.fetchData();
    }
  }
},



  methods: {

 openRouteMap(row) {
    // wir nehmen die WEB-ID (az) als utvonal_az in der Cloud
    this.$router.push({ 
      name: 'UtvonalMap',
      params: { id: row.vir_az }
    });
  },

    openMap(gpsString) {
    
     console.log('GPS Click:', gpsString); // <- Debug-Ausgabe
      if (!gpsString || !gpsString.includes(',')) return;
      this.selectedGPS = gpsString;
      this.showMap = true;
    },


    startEdit(row) {
      this.$emit('edit-start', row);
      this.editRow = row.az;
    },


    async fetchData() {
      try {

         this.isLoading = true;
        this.data = []; // wichtig bei Wechsel
        const postData = {
          ceg_az: this.ceg_az,
          search: this.search,
          table: this.configKey
        };
        console.log('fetchData',postData);
        const response = await axiosInstance.post(this.config.api.list, postData);
        if (response.data?.data) {
          this.data = response.data.data;
        }
        this.resetNewRow();
      } catch (error) {
        console.error('Hiba a listázáskor:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveRow(row) {
      try {
        const postData = {
          table: this.configKey,
          record: row.az,
          data: {}
        };
        this.config.fields.forEach(field => {
          if (!['az', 'timest'].includes(field.key)) {
            postData.data[field.key] = row[field.key];
          }
        });
        console.log('saveRow',postData);
        const response = await axiosInstance.post(this.config.api.save, postData);
        if (response.data.success) {
          this.editRow = null;
          this.fetchData();
        } else {
          console.error('Mentés sikertelen:', response.data);
        }
      } catch (error) {
        console.error('Hiba a mentéskor:', error);
      }
    },
    async addRow() {
      try {
        const postData = {
          table: this.configKey,
          data: { ...this.newRow }
        };
        console.log('addRow',postData);
        const response = await axiosInstance.post(this.config.api.save, postData);
        if (response.data.success) {
          this.fetchData();
        } else {
          console.error('Mentés sikertelen:', response.data);
        }
      } catch (error) {
        console.error('Hiba az új mentésénél:', error);
      }
    },
    resetNewRow() {
      this.config.fields.forEach(field => {
        if (Object.prototype.hasOwnProperty.call(field, 'default')) {
          const def = field.default;
          this.newRow[field.key] = typeof def === 'function' ? def(this.$store) : def;
        } else {
          this.newRow[field.key] = '';
        }
      });
    },
    scrollToNewRow() {
      this.$nextTick(() => {
        const el = this.$refs.newRow;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }
};
</script>

<style scoped>
.table-container {
  max-height: 700px;
  overflow-y: auto;
}

.table td, .table th {
  font-size: 13px;
  vertical-align: middle;
  padding: 0.2rem 0.4rem;
  line-height: 1.1;
}

.sticky-header th {
  position: sticky;
  top: 0;
  background: rgba(185, 231, 227, 0.842);
  z-index: 2;
}

input.form-control-sm, select.form-control-sm {
  padding: 0.2rem 0.4rem;
  font-size: 13px;
  line-height: 1.1;
}

.d-flex.gap-2 > * + * {
  margin-left: 0.5rem;
}
</style>
